module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C147",
    staticStyle: {
      "margin-top": "5%"
    }
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xxi"
    }
  }), _vm._v("A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("NNALS OF A")]), _vm._v(" Q"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UIET")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EIGHBOURHOOD")])])]), _vm._v(" "), _c('p', {
    staticClass: "C148",
    staticStyle: {
      "margin-bottom": "4%"
    }
  }, [_c('strong', [_vm._v("1867")])]), _vm._v(" "), _c('p', {
    staticClass: "C149"
  }, [_vm._v("The Cullen Collection")]), _vm._v(" "), _c('p', {
    staticClass: "C150"
  }, [_vm._v("Volume 6")]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00246.jpeg",
      "width": "67%"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "C94"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "height": "auto",
      "src": "Images/image00247.jpeg",
      "width": "81%"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e24020a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0008.vue
// module id = 84
// module chunks = 0